let apiClientInstance: Awaited<ReturnType<typeof useApi>> | null = null;

const apiClient = async () => {
  if (!apiClientInstance) {
    apiClientInstance = await useApi();
  }
  return apiClientInstance;
};

export default apiClient;
